import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/townsquare-screen-space-flags';

import { ThemeSyncModal } from '../../../components/theme-sync-modal';

import type { MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type HydrationResult = MessageTemplateContext & {
	identityBaseUrl: string;
};

type RenderProps = HydrationResult & PlacementRenderProps & { messageInstanceId: string };

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),

		Component: ({ dismiss, identityBaseUrl }: RenderProps) => {
			return <ThemeSyncModal identityBaseUrl={identityBaseUrl} onDismiss={dismiss} />;
		},
	},
});
